import * as React from 'react';
import { SVGProps } from 'react';

const CommentIcon = (props: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 40 41"
    fill="none"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m23.158 30.425 6.617 4.963v-4.963h1.654a3.307 3.307 0 0 0 3.308-3.309v-9.925a3.307 3.307 0 0 0-3.308-3.308H18.195a3.307 3.307 0 0 0-3.308 3.308v9.925a3.307 3.307 0 0 0 3.308 3.309h4.963Z"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M14.886 25.463 9.924 28.77V23.81H8.269A3.308 3.308 0 0 1 4.961 20.5v-9.925a3.307 3.307 0 0 1 3.308-3.308h14.888a3.307 3.307 0 0 1 3.309 3.308v3.308M20.563 22.096a.083.083 0 1 1-.117.116.083.083 0 0 1 .117-.116ZM24.872 22.096a.083.083 0 1 1-.117.116.083.083 0 0 1 .117-.116ZM29.18 22.096a.083.083 0 1 1-.117.116.083.083 0 0 1 .117-.116Z"
    />
  </svg>
);
export default CommentIcon;
